// Friendly names for document categories (per-person documents).
const LABELS = {
  contract: 'Contract',
  offer: 'Offer letter',
  letter: 'Letter',
  other: 'Other',
  id: 'Photo ID',
  right_to_work: 'Right to work',
  p45: 'P45 / starter checklist',
  bank: 'Bank details',
};

export const categoryLabel = (c) => LABELS[c] || (c ? c.replace(/_/g, ' ') : 'Other');

// What an admin can pick when sending someone a document.
export const SEND_CATEGORIES = ['contract', 'letter', 'other'];
